/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Dynamic Font Size

Inspiration: https://codepen.io/Kniffen/pen/jqaBvq

*/

$(function(){

    function initDynamicFontSize() {

        // first of all, reset font-size (when viewport changes)
        $('.dynamic-font-size').css('font-size','');

        // second, find container and loop!
        var $containers = $('.dynamic-font-size-container');

        $containers.each(function(){

            var $container = $(this);
            var $items = $container.find('.dynamic-font-size');

            $items.each(function(){

                var $item = $(this);
                var $text = $( $item ),
                    fontSize = 14,
                    changes = 0,
                    success = true;

                while( $text.width() <= $container.width() ){
                    $text.css( 'font-size', fontSize + 'px');
                    fontSize++;
                    changes++;

                    if (changes > 500) {
                        success = false;
                        break;
                    }
                }

                if( changes > 0 ) {
                    if( success ){
                        fontSize -= 2;
                    }else{
                        fontSize -= changes;
                        $text.css('font-size', fontSize + 'px');
                    }
                }
            });

        });

    }

    // safety first, init with some delay (Safari didn't render the font size)
    setTimeout(function(){
        initDynamicFontSize();
    },100);

    $(window).on('initDynamicFontSize viewportWidthHasChanged',function(){
        initDynamicFontSize();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/dynamic-font-size.js